<script setup lang="ts">
defineProps<{ event: EventCard; placeholder?: boolean; sizes?: string }>();
</script>

<template>
  <CrystallizeImage
    v-if="event.cover"
    aria-hidden="true"
    :image="event.cover"
    :sizes="sizes"
    img-class="rounded-t-2xl object-cover max-h-48 w-full"
  />
  <StaticAsset
    v-else-if="placeholder"
    folder="images"
    file="aschehoug_lysboks.png"
    aria-hidden="true"
    class="max-h-48 w-full rounded-t-2xl object-cover"
  />
</template>
